import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import store from '../../../store/index';
import { resolveSubscriptionAccess } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/mantap'),
      name: 'mantap',
      component: Index,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: async (to, from, next) => {
        const accountId = to.params.accountId;
        const { hasActiveSubscription, hasError } =
          await resolveSubscriptionAccess(store, accountId);
        if (hasError) {
          return next({
            name: 'subscription_error',
            params: { accountId },
            query: { redirect: to.fullPath },
          });
        }
        if (!hasActiveSubscription) {
          return next({ name: 'pricing_table', params: { accountId } });
        }
        if (accountId.toString() !== '203') {
          return next({ name: 'dashboard' });
        }
        return next();
      },
    },
  ],
};
